import DirectDepositInstantSwitchIntroScreen from 'features/directDeposit/screens/DirectDepositInstantSwitchIntroScreen';
import LoadingSpinner from 'shared/components/vxl/loading/LoadingSpinner/LoadingSpinner';
import { useDirectDepositLoadingComponent } from 'shared/hooks/pinwheel/useDirectDepositLoadingComponent/useDirectDepositLoadingComponent';

interface DirectDepostLoaderProps {
  defaultLoadingComponent?: React.ReactNode;
  isLoadingConditions?: boolean;
  isPinwheelLoading?: boolean;
}

const DirectDepositLoader = ({
  defaultLoadingComponent,
  isLoadingConditions,
  isPinwheelLoading,
}: DirectDepostLoaderProps) => {
  const { skipIntroScreen } = useDirectDepositLoadingComponent();

  const defaultLoadingSpinner = defaultLoadingComponent ?? <LoadingSpinner />;

  if (!skipIntroScreen || isLoadingConditions) {
    return defaultLoadingSpinner;
  }

  return isPinwheelLoading ? <DirectDepositInstantSwitchIntroScreen /> : null;
};

export default DirectDepositLoader;
